import { } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { FileTypeCopySource } from './file-type.copysource';
import { AzureBlobFSDataset } from 'app/model/dataset/azure-blob-fs.dataset';

@Metamodel.model({
    name: 'AzureBlobFSSource',
    display: [],
    tags: { datasetModel : Metamodel.modelFor(AzureBlobFSDataset)}
})
export class AzureBlobFSCopySource extends FileTypeCopySource {
}
